import React, { Component, Fragment } from "react";
import Loading from "../../../shared/Loading/Loading";
import Pill from "../../../shared/Pill/Pill";
import { withGetScreen } from "react-getscreen";
import Select from "../../../shared/Select/Select";
import Card from "../../../shared/Card/Card";

class RankingOffer extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { loading, fidelities, selectSelected, ...props } = this.props;

		let fidelitiesArray = [];

		fidelities.filter(airline =>
			airline.fidelities.map(fb => {
				fb.airlineAcronym = airline.airlineAcronym;
				fidelitiesArray.push(fb);
			})
		);
		fidelitiesArray = fidelitiesArray.sort(
			(a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
		);

		let selectData = [];

		fidelities.map(airline => {
			return airline.fidelities.map(fd => {
				selectData.push({ value: fd.id, label: `${fd.name} - ${airline.airlineAcronym}` });
			});
		});
		selectData = selectData.sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));

		let selectedFidelity = selectData.find(f => f.value == this.props.selected);

		const pills = loading ? (
			<Loading />
		) : (
			<div className="offers-ranking-page__pills">
				{this.props.isMobile() ? (
					<Select
						options={selectData}
						optionsSize={5}
						selected={selectedFidelity || selectSelected}
						onChange={e => this.props.select(e.value, e)}
						data-action="ranking-offer-fidelity-select"
					/>
				) : (
					fidelitiesArray.map(fd => {
						return (
							<Pill
								className="offers-ranking-page__pills--green-card"
								onClick={e => this.props.select(fd.id)}
								selected={this.props.selected === fd.id}
								key={fd.id}
								data-action="ranking-offer-fidelity"
							>
								<strong>{fd.name}</strong>
								<span> - {fd.airlineAcronym}</span>
							</Pill>
						);
					})
				)}
			</div>
		);
		return this.props.isMobile() ? (
			<Card>
				<h1 className="offers-ranking-page__title">RANKING DE OFERTAS</h1>
				<p className="offers-ranking-page__subtitle">Selecione um programa de fidelidade:</p>
				{pills}
			</Card>
		) : (
			<Fragment>
				<h1 className="offers-ranking-page__title">RANKING DE OFERTAS</h1>
				<p className="offers-ranking-page__subtitle">Selecione um programa de fidelidade:</p>
				{pills}
			</Fragment>
		);
	}
}

export default withGetScreen(RankingOffer, {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
